const successUpCircle = (state = false, action) => {
    switch (action.type) {
        case "UP_CIRCLE_SUCCESS":
            return action.data;
        case "RESET_UP_CIRCLE":
            return action.data;
        default:
            return state;
    }
}

export default successUpCircle;